/** @format */

import { Box } from '@mui/material';

export default function PrintMetaDetails() {
  const now = new Date();

  const date = now.toLocaleDateString('en-GB');

  const time = now.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const url = typeof window !== 'undefined' ? window.location.href : '';

  let printedBy = 'Admin';

  try {
    const storedUser = localStorage.getItem('USER_DETAILS');

    if (storedUser) {
      const userDetails = JSON.parse(storedUser);

      const username =
        userDetails?.username ||
        userDetails?.preferred_username ||
        '';

      if (username) {
        const capitalisedUsername =
          username.charAt(0).toUpperCase() + username.slice(1);

        printedBy =
          username.toLowerCase() === 'alembic'
            ? 'Admin'
            : capitalisedUsername;
      }
    }
  } catch {
    printedBy = 'Admin';
  }

  return (
    <Box
      className="print-meta-details"
      sx={{
        display: 'none',

        '@media print': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 1.5,
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          maxWidth: '42%',
          whiteSpace: 'nowrap',
          fontFamily: '"Public Sans", sans-serif',
          fontSize: '9px',
          lineHeight: 1.2,
          color: '#475569',
        },
      }}
    >
      <Box className="print-meta-detail">
        <span className="print-meta-label">Printed by:</span>{' '}
        <span className="print-meta-value">{printedBy}</span>
      </Box>

      <Box className="print-meta-detail">
        <span className="print-meta-label">Date:</span>{' '}
        <span className="print-meta-value">{date}</span>
      </Box>

      <Box className="print-meta-detail">
        <span className="print-meta-label">Time:</span>{' '}
        <span className="print-meta-value">{time}</span>
      </Box>

      <Box
        className="print-meta-detail"
        sx={{
          minWidth: 0,
          maxWidth: '260px',
        }}
      >
        <span className="print-meta-label">URL:</span>{' '}
        <span
          className="print-meta-value print-meta-url"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {url}
        </span>
      </Box>
    </Box>
  );
}
